import { render, staticRenderFns } from "./CreateQR.vue?vue&type=template&id=bf3fe140&scoped=true&"
import script from "./CreateQR.vue?vue&type=script&lang=js&"
export * from "./CreateQR.vue?vue&type=script&lang=js&"
import style0 from "./CreateQR.vue?vue&type=style&index=0&id=bf3fe140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3fe140",
  null
  
)

export default component.exports